import React from 'react'
import { 
  Chip,
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow 
} from '@material-ui/core';

export const PracticasAgrupadasTable = ({items, page, rowsPerPage, 
  onlyRead = true, setItemDelete, setOpenModalDelete}) => {

  return (
    <>
      {items.length > 0 ? (
        <Table size={"small"}>
          <TableHead
            style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
          >
            <TableRow style={{ display: "grid" }}>
              <TableCell style={{ width: "100%" }}></TableCell>                    
            </TableRow>
          </TableHead>
          <TableBody
            style={{ display: "block", maxHeight: "29rem", overflowY: "auto" }}
          >
            {items.length > 0 && (
              items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, index) => {            
                return (
                  <TableRow style={{ display: "grid" }}>
                    <TableCell style={{ width: "100%" }}>
                      {onlyRead 
                        ?
                          <Chip
                            key={index}
                            style={{margin: 0.5}}
                            label={item.practica.codNom + " - " + item.practica.desNom}
                          />
                        :
                          <Chip
                            key={index}
                            style={{margin: 0.5}}
                            label={item.practica.codNom + " - " + item.practica.desNom}
                            onDelete={() => {setItemDelete(item); setOpenModalDelete(true);}}
                          />
                        }
                      </TableCell>
                    </TableRow>
                );
              }))}  
          </TableBody>
        </Table>
      ) : (
        <div style={{ fontStyle: "italic", marginTop: 25, marginLeft: 25 }}>No hay practicas</div>
      )}
    </>
  )
}
